<template>
  <v-list
    two-line
    class="pa-0"
  >

    <div v-if="!contactDetailsData.length">
      <v-divider v-if="!noDividers"></v-divider>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title class="grey--text">אין פרטי קשר</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </div>

    <div
      v-for="(type, typeIndex) in contactDetailTypes"
      :key="`t${typeIndex}`"
      v-if="contactDetails(type._id).length"
    >
      <v-divider v-if="!noDividers"></v-divider>

      <v-list-tile
        v-for="(contactDetail, contactDetailIndex) in contactDetails(type._id)"
        :key="`cd${contactDetailIndex}`"
        @click=""
      >
        <v-list-tile-action>
          <v-icon
            color="primary"
            v-if="contactDetailIndex === 0"
          >{{ type.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content
          v-clipboard:copy="contactDetail.data"
          v-clipboard:success="onCopySuccess"
          v-clipboard:error="onCopyError"
        >
          <v-list-tile-title
            class="text-sm-right"
            dir="ltr"
          >{{ contactDetailTypes[contactDetail.type || 'NO_TYPE'].formatAsPhoneNumber ? formatPhoneNumber(contactDetail.data, (internationalPhoneNumber ? 'INTERNATIONAL': 'NATIONAL')) : contactDetail.data }}</v-list-tile-title>
          <v-list-tile-sub-title class="text-sm-right">{{ contactDetail.description }}</v-list-tile-sub-title>
        </v-list-tile-content>

        <!-- <v-list-tile-action v-if="contactDetailTypes[contactDetail.type].formatAsPhoneNumber">
          <v-btn
            icon
            ripple
            @click="internationalPhoneNumber = !internationalPhoneNumber"
          >
            <v-icon color="grey lighten-1">language</v-icon>
          </v-btn>
        </v-list-tile-action> -->

        <v-list-tile-action>
          <v-menu
            bottom
            right
          >
            <v-btn
              slot="activator"
              color="primary"
              flat
              icon
              :loading="removing[contactDetail._id]"
            >
              <v-icon>more_vert</v-icon>
            </v-btn>

            <v-list>
              <v-list-tile
                @click="internationalPhoneNumber = !internationalPhoneNumber"
                v-if="contactDetailTypes[contactDetail.type  || 'NO_TYPE'].formatAsPhoneNumber"
              >
                <v-list-tile-title>{{ internationalPhoneNumber ? 'הצג מקומי' : 'הצג בינלאומי' }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                v-for="(item, i) in menuItems"
                :key="'menu' + i"
                @click="item.click(contactDetail)"
                v-if="!item.rolesApplied || shouldShow(roles, $store.getters['user/user'])"
              >
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-list-tile-action>

        <!-- <v-list-tile-action>
          <v-btn
            icon
            ripple
            v-clipboard:copy="contactDetail.data"
            v-clipboard:success="onCopySuccess"
            v-clipboard:error="onCopyError"
          >
            <v-icon color="grey lighten-1">content_copy</v-icon>
          </v-btn>
        </v-list-tile-action> -->
      </v-list-tile>
    </div>
  </v-list>
</template>

<script>
import { format } from "date-fns";
import { mapState } from "vuex";
import { parsePhoneNumber } from "libphonenumber-js";
import shouldShow from "@/utils/shouldShow";

export default {
  data() {
    return {
      internationalPhoneNumber: true,
      removing: {},
      menuItems: [
        {
          title: "העתקה",
          click: contactDetail => {
            this.$copyText(contactDetail.data).then(() => {
              this.onCopySuccess();
            });
          }
        },
        {
          title: "עריכה",
          click: contactDetail => {
            this.edit(contactDetail);
          },
          rolesApplied: true
        },
        {
          title: "מחיקה",
          click: contactDetail => {
            this.remove(contactDetail);
          },
          rolesApplied: true
        }
      ]
    };
  },
  computed: {
    contactDetailTypes() {
      return Object.assign({}, this.$store.state.entities.contactDetailTypes, {
          NO_TYPE: {
            _id: "NO_TYPE",
            icon: "help",
            formatAsPhoneNumber: false
          }
        })
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
    // contactDetailTypes() {
    //   return Object.values(this.contactDetailTypes).concat(this.noType);
    // }
  },
  props: [
    "contactDetailsData",
    "noDividers",
    "parentResource",
    "parentId",
    "roles"
  ],
  methods: {
    format,
    shouldShow,
    nl2br(val) {
      return val.replace(/(?:\r\n|\r|\n)/g, "<br />");
    },
    contactDetails(type) {
      if (type === "NO_TYPE") {
        return this.contactDetailsData.filter(item => {
          return !item.type;
        });
      } else {
        return this.contactDetailsData.filter(item => {
          return item ? item.type === type : false;
        });
      }
    },
    onCopySuccess() {
      this.$store.dispatch("SHOW_SNACKBAR", {
        text: "המידע הועתק",
        color: "success"
      });
    },
    onCopyError(err) {
      this.$store.dispatch("SHOW_SNACKBAR", {
        text: err.message,
        color: "error"
      });
    },
    formatPhoneNumber(number, format) {
      try {
        const phoneNumber = parsePhoneNumber(number);
        return phoneNumber.format(format);
      } catch (err) {
        if (err.message === 'INVALID_COUNTRY') {
          try {
            const phoneNumber = parsePhoneNumber('+' + number.replace('(', ''));
            return phoneNumber.format(format);
          } catch(err) {
            // console.log('formatPhoneNumber', err);
          }
        }
        // console.log('formatPhoneNumber', err);
        return number;
      }
    },
    edit(entity) {
      let resource = this.$store.state.resources.contactDetail;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew: false
      });
      this.entityEditDialog = true;
    },
    remove(contactDetail) {
      this.$confirm("האם למחוק את איש הקשר?").then(res => {
        if (!res) {
          return;
        }
      this.$set(this.removing, contactDetail._id, true);
      this.$store
        .dispatch("REMOVE_ENTITY", {
          url: "/contact-details",
          entityType: "contactDetails",
          id: contactDetail._id
        })
        .then(() => {
          this.$store.dispatch("CLEAR_CACHE").then(() => {
            this.$store.dispatch("API_GET", {
              url: `${this.parentResource.endpoint}/` + this.parentId,
              entityType: this.parentResource.entityType,
              schema: this.parentResource.listSchema
            });
          });
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: "הפריט נמחק",
            color: "success"
          });
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.$set(this.removing, contactDetail._id, false);
        });
      });
    }
  },
  watch: {},
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ContactDetailsList.vue